/* Shelving Racking Co product page (8-10-2026; longspan bay widths 11-10-2026; order line details 12-10-2026) */
(function () {
  var root = document.querySelector('[data-srp]');
  var jsonEl = document.querySelector('[data-srp-json]');
  if (!root || !jsonEl || root.__srp) return;
  root.__srp = true;
  var D; try { D = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var amt = (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (window.SRP_MONEY || '£{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function fmt(n) { return n >= 10000 ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : String(n); }
  function num(s) { var m = /(\d+(?:\.\d+)?)/.exec(String(s || '')); return m ? parseFloat(m[1]) : null; }
  function idx(re) { for (var i = 0; i < D.options.length; i++) if (re.test(D.options[i])) return i; return -1; }

  var T = D.title;
  var PART = /\bkit\b|wall ti|connector|additional|extra shel|\bshelf\b|\bbeams?\b|bracket|\bclips?\b/i.test(T);
  var SHELF = /shelving|racking|\bunit\b|\bbay\b/i.test(T) && !/trolley|truck|ladder|step|mat\b/i.test(T) && !PART;
  var mh = /(\d{3,4})\s?mm\s*(?:high|height|tall)/i.exec(T), TH = mh ? parseInt(mh[1], 10) : null;
  var mm = /^\s*(\d+)\s*x\s/i.exec(T), MULTI = mm ? parseInt(mm[1], 10) : 0;
  var ml = /(\d)\s*(?:levels?|tiers?)\b/i.exec(T), TLV = ml ? parseInt(ml[1], 10) : null;
  var mp = /\bpack of\s*(\d+)/i.exec(T); if (mp) MULTI = parseInt(mp[1], 10);
  /* Longspan (11-10-2026): the width option is the BEAM width. Tufferman's spec table gives the installed
     sizes: external bay width = beam + 100mm (two 50mm upright frames), clear entry = beam - 10mm.
     An extension bay brings one frame, so it adds beam + 50mm to an existing run. */
  var LS = /longspan/i.test(T), LSEXT = LS && /extension/i.test(T), UP = 50;
  var IW = idx(/width/i), ID = idx(/depth/i), IL = idx(/levels?|tiers?|decks?/i), IDIM = idx(/dimension/i);
  function dims(v) {
    var r = { w: IW > -1 ? num(v.o[IW]) : null, d: ID > -1 ? num(v.o[ID]) : null, lv: IL > -1 ? num(v.o[IL]) : TLV, h: TH };
    if (IDIM > -1) {
      var s = String(v.o[IDIM] || ''), a;
      if ((a = /(\d{2,4})\s*d\b/i.exec(s))) r.d = +a[1];
      if ((a = /(\d{2,4})\s*w\b/i.exec(s))) r.w = +a[1];
      if ((a = /(\d{2,4})\s*h\b/i.exec(s))) r.h = +a[1];
    }
    return r;
  }

  /* ---------- gallery ---------- */
  var track = $('[data-srp-track]'), slides = track ? $$('.srp-slide', track) : [], thumbs = $$('.srp-thumb'), count = $('[data-srp-count]'), cur = 0;
  function go(i) { if (!slides[i]) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
  function mark(i) {
    cur = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
  }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var best = 0, bd = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = k; } });
        if (best !== cur) mark(best);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, cur + 1)); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, cur - 1)); } });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-i'), 10)); }); });

  /* ---------- variants ---------- */
  var V = D.variants;
  var variant = V.filter(function (v) { return v.id === D.current; })[0] || V[0];
  var sel = variant.o.slice();
  var form = $('[data-srp-form]'), idIn = $('[data-srp-id]'), qtyIn = $('[data-srp-qty]');
  var addBtn = $('[data-srp-add]'), nowBtn = $('[data-srp-now]'), msg = $('[data-srp-msg]');
  function find(o) { return V.filter(function (v) { return v.o.every(function (x, i) { return x == null || x === o[i]; }); })[0]; }
  /* depth and levels side by side when there are exactly three short options */
  (function () {
    var o = $('[data-srp-opts]'), boxes = $$('.srp-opt');
    if (!o || boxes.length !== 3) return;
    var short = [1, 2].every(function (i) { return $$('.srp-tile', boxes[i]).length <= 3; });
    if (short) o.classList.add('srp-opts--pair');
  })();
  /* millimetre options read as sizes on the tiles */
  $$('.srp-opt').forEach(function (box) {
    var oi = parseInt(box.getAttribute('data-oi'), 10);
    if (!/\(mm\)/i.test(D.options[oi] || '')) return;
    $$('.srp-tile span', box).forEach(function (sp) { if (/^\d+$/.test(sp.textContent.trim())) sp.textContent = sp.textContent.trim() + 'mm'; });
  });
  /* proportional bars on a numeric width option */
  (function () {
    if (IW < 0) return;
    var box = $$('.srp-opt')[IW]; if (!box) return;
    var tiles = $$('.srp-tile', box), vals = tiles.map(function (t) { return num(t.getAttribute('data-v')); });
    if (vals.some(function (x) { return x == null; })) return;
    var max = Math.max.apply(null, vals);
    tiles.forEach(function (t, k) { var b = $('.srp-bar', t); b.style.width = Math.round(vals[k] / max * 100) + '%'; b.hidden = false; });
  })();
  function basis(v) {
    var d = dims(v), p = [];
    p.push('per ' + (MULTI > 1 ? 'set of ' + MULTI : SHELF ? 'unit' : 'item'));
    if (LS && d.w) p.push(fmt(d.w) + 'mm beam (' + fmt(d.w + 2 * UP) + 'mm overall)' + (d.d ? ' × ' + fmt(d.d) + 'mm deep' : ''));
    else if (d.w && d.d) p.push(fmt(d.w) + ' × ' + fmt(d.d) + 'mm'); else if (d.w) p.push(fmt(d.w) + 'mm wide');
    if (IL > -1 && d.lv) p.push(d.lv + ' levels');
    if (p.length === 1 && v.t && !/default title/i.test(v.t)) p.push(v.t);
    return p.join(' · ');
  }
  function renderOpts() {
    $$('.srp-opt').forEach(function (box) {
      var oi = parseInt(box.getAttribute('data-oi'), 10);
      var ev = $('[data-srp-optval]', box); if (ev) ev.textContent = sel[oi] + (/\(mm\)/i.test(D.options[oi]) && /^\d+$/.test(sel[oi]) ? 'mm' : '');
      $$('.srp-tile', box).forEach(function (t) {
        var val = t.getAttribute('data-v'), on = val === sel[oi];
        t.classList.toggle('on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false');
        var test = sel.slice(); test[oi] = val;
        var hit = find(test);
        t.classList.toggle('na', !hit || !hit.a);
      });
    });
  }
  function apply(fromUser) {
    var v = find(sel) || variant;
    variant = v; sel = v.o.slice();
    idIn.value = v.id;
    $('[data-srp-price]').textContent = money(v.p);
    $('[data-srp-basis]').textContent = basis(v);
    if (addBtn) { addBtn.disabled = !v.a; addBtn.textContent = v.a ? 'Add to basket' : 'Sold out'; }
    if (nowBtn) nowBtn.disabled = !v.a;
    renderOpts();
    if (fromUser && v.m) { var k = slides.map(function (s) { return s.getAttribute('data-mid'); }).indexOf(String(v.m)); if (k > -1) go(k); }
    if (fromUser) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }
    quote(); draw();
  }
  $$('.srp-opt').forEach(function (box) {
    var oi = parseInt(box.getAttribute('data-oi'), 10);
    $$('.srp-tile', box).forEach(function (t) {
      t.addEventListener('click', function () {
        sel[oi] = t.getAttribute('data-v');
        if (!find(sel)) {
          var alt = V.filter(function (v) { return v.o[oi] === sel[oi]; });
          /* keep as many of the other choices as possible */
          alt.sort(function (a, b) {
            var sa = a.o.filter(function (x, i) { return x === sel[i]; }).length + (a.a ? .5 : 0);
            var sb = b.o.filter(function (x, i) { return x === sel[i]; }).length + (b.a ? .5 : 0);
            return sb - sa;
          });
          if (alt[0]) sel = alt[0].o.slice();
        }
        apply(true);
      });
    });
  });

  /* ---------- quantity + add to basket ---------- */
  function q() { var n = parseInt(qtyIn.value, 10); return n > 0 ? n : 1; }
  $$('[data-srp-q]').forEach(function (b) { b.addEventListener('click', function () { qtyIn.value = Math.max(1, q() + parseInt(b.getAttribute('data-srp-q'), 10)); quote(); }); });
  qtyIn.addEventListener('change', function () { qtyIn.value = q(); quote(); });
  /* every chosen option goes with the basket line (12-10-2026); sr-pack.js builds the list and the hidden inputs */
  function props() {
    var o = {};
    $$('[data-srp-props] input', form).forEach(function (i) { var m = /^properties\[(.*)\]$/.exec(i.name); if (m && i.value) o[m[1]] = i.value; });
    if (!Object.keys(o).length && window.__srpOrderProps) o = window.__srpOrderProps();
    return o;
  }
  function add(then) {
    if (!variant.a) return;
    addBtn.disabled = true; nowBtn.disabled = true; msg.textContent = 'Adding to basket…'; msg.className = 'srp-msg';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: q(), properties: props() }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        addBtn.disabled = false; nowBtn.disabled = false;
        if (!res.ok) { msg.className = 'srp-msg err'; msg.textContent = res.j.description || res.j.message || 'Could not add to basket.'; return; }
        msg.textContent = 'Added to your basket.';
        if (then) then();
      })
      .catch(function () { addBtn.disabled = false; nowBtn.disabled = false; form.submit(); });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  nowBtn.addEventListener('click', function () { add(function () { location.href = '/checkout'; }); });

  /* ---------- quote link carries the chosen option and quantity ---------- */
  function quote() {
    var a = $('[data-srp-quote]'); if (!a) return;
    var p = new URLSearchParams({ product: T });
    if (variant.t && !/default title/i.test(variant.t)) p.set('size', variant.t);
    p.set('qty', String(q()));
    a.href = D.quote + '?' + p.toString();
  }

  /* ---------- drawn to scale ---------- */
  var scale = $('[data-srp-scale]');
  function draw() {
    var d = dims(variant);
    if (!d.w || !d.h) { scale.hidden = true; return; }
    var w = d.w, h = d.h, dp = d.d, lv = d.lv, beam = null;
    if (LS) { beam = w; w = beam + 2 * UP; }
    var VW = 720, VH = 450, base = 380, top = 70, gap = 60;
    var person = 1750, pw = person * 0.3;
    var totalMM = w + (dp || 0) + pw;
    var s = Math.min((VW - 200 - (dp ? 2 : 1) * gap) / totalMM, (base - top) / Math.max(h, person));
    var x0 = 100, y0 = base - h * s, out = '';
    var g = '', grid = 250 * s, i;
    for (i = 0; i * grid < VW; i++) g += '<path d="M' + (i * grid).toFixed(1) + ' 0V' + VH + '" class="gl"/>';
    for (i = 0; i * grid < VH; i++) g += '<path d="M0 ' + (base - i * grid).toFixed(1) + 'H' + VW + '" class="gl"/>';
    out += '<g>' + g + '</g>';
    function shelves(x, width) {
      var n = lv || 0, o = '';
      if (!SHELF || !n) return o;
      for (var k = 0; k < n; k++) { var yy = base - 8 - k * ((h * s - 16) / Math.max(1, n - 1)); o += '<path d="M' + x.toFixed(1) + ' ' + yy.toFixed(1) + 'h' + width.toFixed(1) + '" class="sh"/>'; }
      return o;
    }
    /* front */
    if (LS) {
      out += shelves(x0 + UP * s, beam * s);
      out += '<rect x="' + x0 + '" y="' + y0.toFixed(1) + '" width="' + (UP * s).toFixed(1) + '" height="' + (h * s).toFixed(1) + '" style="fill:#2B5BA8"/><rect x="' + (x0 + (w - UP) * s).toFixed(1) + '" y="' + y0.toFixed(1) + '" width="' + (UP * s).toFixed(1) + '" height="' + (h * s).toFixed(1) + '" style="fill:#2B5BA8"/>';
      out += '<text x="' + (x0 + w * s / 2).toFixed(1) + '" y="' + (y0 - 14).toFixed(1) + '" class="lb">' + fmt(w) + 'mm overall (' + fmt(beam) + 'mm beam)</text>';
    } else {
    out += shelves(x0, w * s);
    out += '<path d="M' + x0 + ' ' + y0.toFixed(1) + 'V' + base + 'M' + (x0 + w * s).toFixed(1) + ' ' + y0.toFixed(1) + 'V' + base + '" class="po"/>';
    if (!SHELF || !lv) out += '<rect x="' + x0 + '" y="' + y0.toFixed(1) + '" width="' + (w * s).toFixed(1) + '" height="' + (h * s).toFixed(1) + '" class="bx"/>';
    out += '<text x="' + (x0 + w * s / 2).toFixed(1) + '" y="' + (y0 - 14).toFixed(1) + '" class="lb">' + fmt(w) + 'mm wide</text>';
    }
    out += '<path d="M' + (x0 - 8) + ' ' + y0.toFixed(1) + 'V' + base + '" class="dm"/><text x="' + (x0 - 14) + '" y="' + ((y0 + base) / 2 + 5).toFixed(1) + '" class="lb" text-anchor="end">' + fmt(h) + 'mm</text>';
    out += '<text x="' + (x0 + w * s / 2).toFixed(1) + '" y="' + (base + 28) + '" class="cap">Front</text>';
    var x1 = x0 + w * s + gap;
    if (dp) {
      out += shelves(x1, dp * s);
      out += '<path d="M' + x1.toFixed(1) + ' ' + y0.toFixed(1) + 'V' + base + 'M' + (x1 + dp * s).toFixed(1) + ' ' + y0.toFixed(1) + 'V' + base + '" class="po"/>';
      if (SHELF) out += '<path d="M' + x1.toFixed(1) + ' ' + y0.toFixed(1) + 'L' + (x1 + dp * s).toFixed(1) + ' ' + base + '" class="br"/>';
      else out += '<rect x="' + x1.toFixed(1) + '" y="' + y0.toFixed(1) + '" width="' + (dp * s).toFixed(1) + '" height="' + (h * s).toFixed(1) + '" class="bx"/>';
      out += '<text x="' + (x1 + dp * s / 2).toFixed(1) + '" y="' + (y0 - 14).toFixed(1) + '" class="lb">' + fmt(dp) + 'mm deep</text>';
      out += '<text x="' + (x1 + dp * s / 2).toFixed(1) + '" y="' + (base + 28) + '" class="cap">Side</text>';
      x1 += dp * s + gap;
    }
    var ph = person * s, py = base - ph, u = ph / 8, px = x1 + u;
    out += '<g class="ps"><circle cx="' + px + '" cy="' + (py + u * 0.55) + '" r="' + (u * 0.5) + '"/><rect x="' + (px - u * 0.55) + '" y="' + (py + u * 1.15) + '" width="' + (u * 1.1) + '" height="' + (u * 3) + '" rx="' + (u * 0.3) + '"/><rect x="' + (px - u * 0.85) + '" y="' + (py + u * 1.2) + '" width="' + (u * 0.28) + '" height="' + (u * 2.6) + '" rx="' + (u * 0.14) + '"/><rect x="' + (px + u * 0.57) + '" y="' + (py + u * 1.2) + '" width="' + (u * 0.28) + '" height="' + (u * 2.6) + '" rx="' + (u * 0.14) + '"/><rect x="' + (px - u * 0.5) + '" y="' + (py + u * 4) + '" width="' + (u * 0.42) + '" height="' + (u * 4) + '" rx="' + (u * 0.2) + '"/><rect x="' + (px + u * 0.08) + '" y="' + (py + u * 4) + '" width="' + (u * 0.42) + '" height="' + (u * 4) + '" rx="' + (u * 0.2) + '"/></g>';
    out += '<text x="' + px + '" y="' + (base + 28) + '" class="cap">1.75m person</text>';
    out += '<path d="M20 ' + base + 'H' + (VW - 20) + '" class="fl"/>';
    $('[data-srp-svg]').innerHTML = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" role="img" aria-label="' + esc(fmt(w) + (LS ? 'mm overall width' : 'mm wide') + (dp ? ', ' + fmt(dp) + 'mm deep' : '') + ', ' + fmt(h) + 'mm high, next to a 1.75m person') + '">' + out + '</svg>';
    var f = [];
    if (LS) {
      f.push(['Beam width (the size you picked)', fmt(beam) + 'mm']);
      f.push(['External bay width (outside of uprights)', fmt(w) + 'mm — beam + 100mm']);
      f.push(['Clear entry (usable opening)', fmt(beam - 10) + 'mm']);
      if (LSEXT) f.push(['Adds to your existing run', fmt(beam + UP) + 'mm — it shares one upright with the bay it joins']);
      else if (MULTI > 1) f.push([MULTI + ' bays side by side', fmt(MULTI * w) + 'mm — each bay has its own two uprights']);
    }
    if (dp) { f.push([LS ? 'Footprint per bay' : 'Footprint', fmt(w) + ' × ' + fmt(dp) + 'mm']); f.push(['Floor area', (w * dp / 1e6).toFixed(2) + ' m²']); }
    f.push(['Height', fmt(h) + 'mm']);
    if (SHELF && lv > 1) f.push(['Deck spacing', 'about ' + fmt(Math.round((h - 200) / (lv - 1) / 10) * 10) + 'mm if spread evenly']);
    if (SHELF) f.push(['Ceiling needed', 'over ' + fmt(h) + 'mm, plus room to lift the top deck']);
    $('[data-srp-facts]').innerHTML = f.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    scale.hidden = false;
  }

  /* ---------- description: the whole of it, in two columns when it has a specs/FAQ part ---------- */
  (function () {
    var rte = $('[data-srp-rte]'), side = $('[data-srp-rteside]');
    if (!rte || !side) return;
    var host = rte;
    if (host.children.length === 1 && /^(DIV|SECTION|ARTICLE)$/.test(host.children[0].tagName)) host = host.children[0];
    var kids = Array.prototype.slice.call(host.children);
    var at = -1;
    kids.some(function (el, k) {
      var isHead = /^H[1-6]$/.test(el.tagName) || (el.tagName === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) && el.textContent.trim() === el.children[0].textContent.trim());
      if (k > 0 && isHead && /specification|dimensions|faq|frequently asked/i.test(el.textContent)) { at = k; return true; }
      return false;
    });
    if (at < 2 || at > kids.length - 1) return;
    kids.slice(at).forEach(function (el) { side.appendChild(el); });
    side.hidden = false;
    $('[data-srp-descg]').classList.add('is-split');
  })();

  /* ---------- same range, other heights + parts for it ---------- */
  (function () {
    var R = (D.related || []).filter(Boolean);
    if (!R.length) return;
    function key(t) { return t.replace(/[\s,–-]*\d{3,4}\s?mm\s*(?:high|height|tall)\b/ig, ' ').replace(/[^a-z0-9]+/gi, ' ').trim().toLowerCase(); }
    var k0 = key(T);
    var heights = R.filter(function (p) { return /\d{3,4}\s?mm\s*(?:high|height|tall)/i.test(p.t) && key(p.t) === k0; }).map(function (p) {
      var m = /(\d{3,4})\s?mm\s*(?:high|height|tall)/i.exec(p.t); p.h = +m[1]; p.badge = p.h + 'mm high'; return p;
    }).sort(function (a, b) { return a.h - b.h; }).slice(0, 3);
    var STOP = /^(with|for|and|the|high|capacity|load|premium|heavy|duty|pack|unit|units|steel)$/i;
    var words = T.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 3 && !STOP.test(w); });
    var parts = R.filter(function (p) { return /wall ti|wall fix|additional shel|extra shel|\bshelf\b|connector|\bbeams?\b|bracket|\bkit\b|decking/i.test(p.t); }).map(function (p) {
      var pw = p.t.toLowerCase().split(/[^a-z0-9]+/);
      p.score = words.filter(function (w) { return pw.indexOf(w) > -1; }).length + (/heavy duty/i.test(T) && /heavy duty/i.test(p.t) ? 1 : 0);
      p.badge = /wall/i.test(p.t) ? 'Wall fixing' : /connector/i.test(p.t) ? 'Connector' : /shel/i.test(p.t) ? 'Extra shelf' : 'Accessory';
      return p;
    }).filter(function (p) { return p.score >= 2; }).sort(function (a, b) { return b.score - a.score; });
    var acc = parts.slice(0, Math.max(1, 3 - heights.length));
    var list = heights.concat(acc).slice(0, 4);
    if (!list.length) return;
    var wall = acc.some(function (p) { return /wall/i.test(p.t); });
    var accName = acc.length ? (wall ? 'wall fixing' : acc[0].badge.toLowerCase() + (acc.length > 1 ? 's' : '')) : '';
    $('[data-srp-relh]').textContent = heights.length ? 'Same range, other heights' + (acc.length ? ' — and ' + accName : '') : 'Made to go with it';
    $('[data-srp-rell]').textContent = heights.length ? 'Need a lower unit under a mezzanine, or a taller one for a high bay?' + (wall ? ' Fixing a tall unit to a wall?' : '') : 'Parts listed for this range.';
    $('[data-srp-relg]').innerHTML = list.map(function (p) {
      return '<li class="srp-card"><a class="srp-card__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="600" height="600">' : '') + '<span class="srp-badge">' + esc(p.badge) + '</span></a>' +
        '<div class="srp-card__b"><h3><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3><p class="srp-card__p">' + (p.v ? '<small>from</small> ' : '') + '<b>' + esc(money(p.p)) + '</b></p><a class="srp-btn srp-btn--line" href="' + esc(p.u) + '">' + (p.a ? 'Choose options' : 'Sold out · view') + '</a></div></li>';
    }).join('');
    $('[data-srp-rel]').hidden = false;
  })();

  apply(false);
})();
